var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mt-2"},[_c('b-button',{on:{"click":_vm.saveBtn}},[_vm._v("SAVE")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }